module.exports = __webpack_public_path__ + "96bf07487128bbbaa617047e307f596c.svg";